import React from 'react';
import { i18n } from 'core/i18n';

const { FormattedText } = i18n;
import Storage from 'utilities/storage';
import { PUBLICA_URL } from 'constants/index';

const ButtonUnderstood = ({ onClick }) => {
    const handleClick = event => {
        event.preventDefault();
        onClick && onClick();
        Storage.cookies.remove('accessToken');
        Storage.cookies.remove('refreshToken');
        window.location.href = PUBLICA_URL;
    };

    return (
        <div className="form__buttons form__footer">
            <button type="button" className="form__button form__button-secondary" onClick={handleClick}>
                <FormattedText value="button-understood" />
            </button>
        </div>
    );
};

export default ButtonUnderstood;
